export default __webpack_public_path__ + "static/media/LogoCardPreview.e6a3df49.jpg";